<template>
  <div class="tabContent">
    <vxe-toolbar v-if="isEdit">
      <template v-slot:buttons>
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-primary"
          @click="batchPicking()"
          >{{ $t('salesBill.batchMatchingResults.button.batchPicking') }}</vxe-button
        >
        <vxe-button
          type="primary"
          icon="el-icon-plus"
          class="vxe-btn-delete"
          @click="emptyPicking()"
          >{{ $t('salesBill.batchMatchingResults.button.emptyPicking') }}</vxe-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      border
      class="mytable-style"
      resizable
      show-overflow
      :data="storageLadingPicking"
      :edit-config="editConfig"
      size="mini"
      ref="goodsTable"
      :edit-rules="goodsTableRules"
      auto-resize
      :valid-config="{ autoPos: true, message: 'inline' }"
      keep-source
      @edit-actived="editActivedEvent"
      :row-class-name="rowClassName"
      :max-height="$store.state.app.tableHeight"
      :checkbox-config="{ checkMethod: checCheckboxkMethod }"
      :key="keyTime"
      :footer-method="ladingFooterMethod"
      show-footer
    >
      >
      <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
      <vxe-table-column
        type="seq"
        width="60"
        :title="this.$t('salesBill.batchMatchingResults.table.seq')"
      ></vxe-table-column>
      <vxe-table-column
        field="contractDetailNo"
        :title="this.$t('salesBill.batchMatchingResults.table.contractDetailNo')"
        width="60"
      ></vxe-table-column>
      <vxe-table-column
        field="ladingDetailNo"
        :title="this.$t('salesBill.batchMatchingResults.table.ladingDetailNo')"
        width="60"
      ></vxe-table-column>
      <vxe-table-column
        field="productDesc"
        :title="this.$t('salesBill.batchMatchingResults.table.productDesc')"
        width="140"
      ></vxe-table-column>
      <vxe-table-column
        field="availableQuantity"
        :title="this.$t('salesBill.batchMatchingResults.table.availableQuantity')"
        width="80"
      >
        <template v-slot="scope">
          {{ $baseRequest.formatTableColumn(scope.row.availableQuantity, $globalVar.qPoint) }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="ladingUnitName"
        :title="this.$t('salesBill.batchMatchingResults.table.ladingUnitName')"
        width="100"
      ></vxe-table-column>
      <vxe-table-column
        field="salesQuantity"
        :title="this.$t('salesBill.batchMatchingResults.table.salesQuantity')"
        width="80"
      >
        <template v-slot="scope">
          {{ $baseRequest.formatTableColumn(scope.row.salesQuantity, $globalVar.qPoint) }}
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="ladingQuantity"
        title="提单数量"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="99999999999.9999"
            v-model="scope.row.ladingQuantity"
            :precision="isWuMaoAccount ? 8 : $globalVar.qPoint"
            :disabled="true"
            @input="(val) => changeList(val, scope.row, scope)"
            @change="(val) => ladingQuantityChange(val, scope.row, scope)"
          ></input-number>
        </template>
        <template v-slot="scope">
          {{
            $baseRequest.formatTableColumn(
              scope.row.ladingQuantity,
              isWuMaoAccount ? 8 : $globalVar.qPoint
            )
          }}
        </template>
      </vxe-table-column>

      <vxe-table-column field="actualSendQuantity" title="实发数量" width="140">
        <template v-slot="scope">
          {{
            $baseRequest.formatTableColumn(
              scope.row.actualSendQuantity,
              isWuMaoAccount ? 8 : $globalVar.qPoint
            )
          }}
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="customerReceiveQuantity"
        :title="this.$t('salesBill.batchMatchingResults.table.customerReceiveQuantity')"
        width="140"
      >
        <template v-slot="scope">
          {{$baseRequest.formatTableColumn(scope.row.customerReceiveQuantity,$globalVar.qPoint)}}
        </template>
      </vxe-table-column> -->
      <vxe-table-column
        field="businessChangingUnitPrice"
        title="变动单价"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-select
            v-model="scope.row.businessChangingUnitPrice"
            @change="(val) => changeSelect(val, scope)"
            @focus="(val) => getPriceList(scope.row)"
            clearable
            filterable
            :disabled="true"
            v-if="scope.row.priceOptions?.length"
          >
            <el-option-group :key="1" :label="'变动价格 可定价数量 定价时间'">
              <el-option
                v-for="item in scope.row.priceOptions"
                :key="item.id"
                :label="item.temporaryPrice"
                :value="item.priceFlag"
              >
                <span style="float: left">
                  {{ item.temporaryPrice }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ item.availableLadingQuantity }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  {{ item.confirmDate }}
                </span>
              </el-option>
            </el-option-group>
          </el-select>
          <template v-else>
            <p>{{
              (scope.row.businessChangingUnitPrice = scope.row.businessContractUnitPrice.toFixed(6))
            }}</p>
          </template>
        </template>
        <template v-slot="scope">
          <template v-if="scope.row.priceOptions == 0">
            <p>{{
              (scope.row.businessChangingUnitPrice = scope.row.businessContractUnitPrice.toFixed(6))
            }}</p>
          </template>
          <div v-else-if="basicData.exchangeRate == 1">
            {{
              scope.row.businessChangingUnitPrice
                ? $baseRequest.formatTableColumn(
                    scope.row.businessChangingUnitPrice,
                    $globalVar.pPoint
                  )
                : scope.row.businessChangingUnitPrice === 0
                ? 0
                : null
            }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.businessChangingUnitPrice">
              {{
                scope.row.businessChangingUnitPrice
                  ? $t('contractAgency.productTab.originCoin')
                  : null
              }}
              {{
                $baseRequest.formatTableColumn(
                  scope.row.businessChangingUnitPrice,
                  $globalVar.pPoint
                )
              }}
            </p>
            <p class="break-space" v-if="scope.row['businessChangingUnitPriceOther']">
              {{
                scope.row['businessChangingUnitPriceOther']
                  ? $t('contractAgency.productTab.localCoin')
                  : null
              }}
              {{
                $baseRequest.formatTableColumn(
                  scope.row['businessChangingUnitPriceOther'],
                  $globalVar.pPoint
                )
              }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="businessContractUnitPrice"
        :title="this.$t('salesBill.batchMatchingResults.table.businessContractUnitPrice')"
        width="140"
      >
        <template v-slot="scope">
          <div v-if="basicData.exchangeRate == 1">
            {{
              $baseRequest.formatTableColumn(scope.row.businessContractUnitPrice, $globalVar.pPoint)
            }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.businessContractUnitPrice">
              {{
                scope.row.businessContractUnitPrice
                  ? $t('contractAgency.productTab.originCoin')
                  : null
              }}
              {{
                $baseRequest.formatTableColumn(
                  scope.row.businessContractUnitPrice,
                  $globalVar.pPoint
                )
              }}
            </p>
            <p class="break-space" v-if="scope.row['businessContractUnitPriceOther']">
              {{
                scope.row['businessContractUnitPriceOther']
                  ? $t('contractAgency.productTab.localCoin')
                  : null
              }}
              {{
                $baseRequest.formatTableColumn(
                  scope.row['businessContractUnitPriceOther'],
                  $globalVar.pPoint
                )
              }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="businessLadingAmount"
        :title="this.$t('salesBill.batchMatchingResults.table.businessLadingAmount')"
        width="140"
      >
        <template v-slot="scope">
          <div v-if="basicData.exchangeRate == 1">
            {{ $baseRequest.formatTableColumn(scope.row.businessLadingAmount, $globalVar.aPoint) }}
          </div>
          <div v-else>
            <p class="break-space" v-if="scope.row.businessLadingAmount">
              {{
                scope.row.businessLadingAmount ? $t('contractAgency.productTab.originCoin') : null
              }}
              {{
                $baseRequest.formatTableColumn(scope.row.businessLadingAmount, $globalVar.qPoint)
              }}
            </p>
            <p class="break-space" v-if="scope.row['businessLadingAmountOther']">
              {{
                scope.row['businessLadingAmountOther']
                  ? $t('contractAgency.productTab.localCoin')
                  : null
              }}
              {{
                $baseRequest.formatTableColumn(
                  scope.row['businessLadingAmountOther'],
                  $globalVar.qPoint
                )
              }}
            </p>
          </div>
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column
        field="carNo"
        :title="this.$t('salesBill.batchMatchingResults.table.carNo')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <el-input
            v-model="scope.row.carNo"
            @change="(val) => ladingQuantityChange(val, scope.row, scope)"
            @input="$refs.goodsTable.updateStatus(scope)"
            :disabled="rowDisabled"
          ></el-input>
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column
        field="netWeight"
        :title="this.$t('salesBill.batchMatchingResults.table.netWeight')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="99999999999.9999"
            v-model="scope.row.netWeight"
            @change="(val) => ladingQuantityChange(val, scope.row, scope)"
            :clearable="true"
            :precision="$globalVar.qPoint"
            :disabled="rowDisabled"
          ></input-number>
        </template>
        <template v-slot="scope">
          {{ $baseRequest.formatTableColumn(scope.row.netWeight, $globalVar.qPoint) }}
        </template>
      </vxe-table-column> -->
      <!-- <vxe-table-column
        field="deduct"
        :title="this.$t('salesBill.batchMatchingResults.table.deduct')"
        width="140"
        :edit-render="{ type: 'default' }"
      >
        <template v-slot:edit="scope">
          <input-number
            :max="99999999999.9999"
            v-model="scope.row.deduct"
            @change="(val) => ladingQuantityChange(val, scope.row, scope)"
            :clearable="true"
            :precision="$globalVar.qPoint"
            :disabled="rowDisabled"
          ></input-number>
        </template>
        <template v-slot="scope">
          {{ $baseRequest.formatTableColumn(scope.row.deduct, $globalVar.qPoint) }}
        </template>
      </vxe-table-column> -->
      <vxe-table-column
        field="settleBatchNo"
        :title="this.$t('salesBill.batchMatchingResults.table.settleBatchNo')"
        width="140"
      ></vxe-table-column>
    </vxe-table>
    <!-- 拣配结果表格 -->
    <div style="margin-top: 10px">
      <span>{{ this.$t('salesBill.batchMatchingResults.title.result') }}</span>
      <vxe-table
        border
        resizable
        show-overflow
        :data="storageLadingPickingDetailList"
        :edit-config="editConfigPickingDetail"
        size="mini"
        ref="resultTable"
        :edit-rules="feeFormRules"
        auto-resize
        :max-height="$store.state.app.tableHeight"
        :valid-config="{ autoPos: true, message: 'inline' }"
        :footer-method="footerMethod"
        show-footer
      >
        <vxe-table-column
          type="index"
          width="50"
          :title="this.$t('salesBill.batchMatchingResults.table.seq')"
        ></vxe-table-column>
        <vxe-table-column
          field="ladingDetailNo"
          :title="this.$t('salesBill.batchMatchingResults.table.ladingDetailNo')"
          width="60"
        ></vxe-table-column>
        <vxe-table-column
          field="productDesc"
          :title="this.$t('salesBill.batchMatchingResults.table.productDesc')"
        ></vxe-table-column>
        <vxe-table-column
          field="ladingUnitName"
          width="60"
          :title="this.$t('salesBill.batchMatchingResults.table.ladingUnitName')"
        ></vxe-table-column>
        <vxe-table-column
          field="supplier"
          :title="this.$t('salesBill.batchMatchingResults.table.supplier')"
        ></vxe-table-column>
        <vxe-table-column
          field="businessContractUnitPrice"
          :title="this.$t('salesBill.batchMatchingResults.table.businessContractUnitPrice')"
        >
          <template v-slot="scope">
            {{
              $baseRequest.formatTableColumn(scope.row.businessContractUnitPrice, $globalVar.pPoint)
            }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="pickingQuantity" title="拣配数量">
          <template v-slot="scope">
            {{
              $baseRequest.formatTableColumn(
                scope.row.pickingQuantity,
                isWuMaoAccount ? 8 : $globalVar.qPoint
              )
            }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="actualSendQuantity" title="实发数量" width="120">
          <template v-slot="scope">
            {{
              $baseRequest.formatTableColumn(
                scope.row.actualSendQuantity,
                isWuMaoAccount ? 8 : $globalVar.qPoint
              )
            }}
          </template>
        </vxe-table-column>
        <!--  <vxe-table-column
          field="customerReceiveQuantity"
          :title="this.$t('salesBill.batchMatchingResults.table.customerReceiveQuantity')"
          width="140"
          :edit-render="{type: 'default'}"
        >
        <template v-slot:edit="scope">
            <input-number
              v-model="scope.row.customerReceiveQuantity"
              :max="scope.row.pickingQuantity"
              :disabled="(basicData.deliveryMethod == 'JHFS01' ||
                          basicData.deliveryMethod == 'JHFS02' ||
                          basicData.deliveryMethod == 'JHFS03' ||
                          basicData.deliveryMethod == 'JHFS07')?true:scope.row.disabled"
              :precision="3"
              @change="(val)=>cusReceiveQuantityChange(val,scope)"
            ></input-number>
        </template>
        <template v-slot="scope">
             {{Number(scope.row.customerReceiveQuantity).toFixed(3)||0}}
         </template>
        </vxe-table-column> -->
        <!-- 拣配金额 -->
        <vxe-table-column
          field="businessPickingAmount"
          :title="this.$t('salesBill.batchMatchingResults.table.businessPickingAmount')"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot="scope">
            {{ $baseRequest.formatTableColumn(scope.row.businessPickingAmount, $globalVar.aPoint) }}
          </template>
          <template v-slot:edit="scope">
            <input-number-ad
              :precision="2"
              :min="0"
              :controls="false"
              :max="99999999999999"
              v-model="scope.row['businessPickingAmount']"
              :disabled="rowDisabled"
            ></input-number-ad>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="businessInboundBatchNo"
          :title="this.$t('salesBill.batchMatchingResults.table.businessInboundBatchNo')"
          width="120"
        ></vxe-table-column>
        <vxe-table-column
          field="settleBatchNoForShow"
          :title="this.$t('salesBill.batchMatchingResults.table.settleBatchNo')"
          width="140"
        ></vxe-table-column>
        <vxe-table-column
          field="shipComplete"
          width="80"
          :title="$t('transportDeliveryOrder.form.good.shipComplete')"
        >
          <template v-slot="{ row }">
            <span>{{ row.shipComplete == 'Y' ? '是' : '否' }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <batch-picking-dialog
      ref="batchPickingDialog"
      :basicData="basicData"
      :storageLadingPickingDetailList="storageLadingPickingDetailList"
      @changeResult="changeResult"
    ></batch-picking-dialog>
  </div>
</template>

<script>
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import batchPickingDialog from './batchPickingDialog';
  import inputNumber from '@/components/form-item/input-number';
  import { digitUppercase, toUpperCase, toFixedNumber } from '@/common/js/util';
  import Big from 'big.js';
  export default {
    props: {
      storageLadingPickings: {
        type: Array,
        default: () => [],
      },
      storageLadingPickingDetail: {
        type: Array,
        default: () => [],
      },
      isEdit: {
        type: Boolean,
        default: () => true,
      },
      basicData: {
        type: Object,
        default: () => {},
      },
      deliveryMethod: {
        type: String,
        default: '',
      },
      deleveryFlag: {
        type: Boolean,
        default: () => false,
      },
      editConfigFlag: {
        type: Boolean,
        default: () => false,
      },
    },
    watch: {
      storageLadingPickings: {
        handler(v) {
          console.log('变化了嘛');
          this.storageLadingPicking = JSON.parse(JSON.stringify(v));
        },
        deep: true,
        immediate: true,
      },
      // storageLadingPickings() {
      //   this.storageLadingPicking = this.storageLadingPickings;
      //   setTimeout(() => {
      //     this.upDataOption();
      //   }, 0);
      // },
      storageLadingPickingDetail(val) {
        this.storageLadingPickingDetailList = val;
      },
      basicData(val) {
        this.basicData = val;
      },
      deliveryMethod(val) {
        this.basicData.deliveryMethod = val;
        this.getDeliveryMenthod();
      },
    },
    components: {
      batchPickingDialog,
      inputNumber,
    },
    data() {
      return {
        maxActualSendQuantity: 99999999999.999999,
        feeFormRules: {},
        tableToolbar: {},
        editConfig: {},
        editConfigPickingDetail: {},
        // basicData: {},
        storageLadingPicking: [],
        storageLadingPickingDetailList: [], //结果明细
        rowDisabled: false, //行是否可编辑
        keyTime: new Date().getTime(),
        point: 8,
      };
    },
    computed: {
      goodsTableRules() {
        return {
          ladingQuantity: [
            {
              required: true,
              message: this.$t('salesBill.baseInfo.label.pleaseChooseWrite'),
              trigger: ['change', 'blur'],
            },
          ],
          businessChangingUnitPrice: [
            {
              required: true,
              message: '必填字段',
              trigger: ['change', 'blur'],
            },
          ],
          // businessChangingUnitPrice: [
          //   {
          //     required: true,
          //     message: this.$t('salesBill.message.businessChangingUnitPriceMsg'),
          //     trigger: ['change', 'blur'],
          //   },
          // ],
          carNo: [
            {
              required: true,
              message: this.$t('salesBill.message.carNoMsg'),
              trigger: ['change', 'blur'],
            },
          ],
          netWeight: [
            {
              required: true,
              message: this.$t('salesBill.message.netWeightMsg'),
              trigger: ['change', 'blur'],
            },
          ],
          deduct: [
            {
              required: true,
              message: this.$t('salesBill.message.deductMsg'),
              trigger: ['change', 'blur'],
            },
          ],
        };
      },
    },
    created() {
      this.feeFormRules = {};
      this.storageLadingPickingDetailList = JSON.parse(
        JSON.stringify(this.storageLadingPickingDetail)
      );
      this.storageLadingPicking = JSON.parse(JSON.stringify(this.storageLadingPickings));
      this.getOvershippend(this.storageLadingPicking[0].contractNo);
    },
    mounted() {
      this.point = this.isWuMaoAccount ? 8 : this.$globalVar.qPoint;
      this.editConfig = this.isEdit ? { trigger: 'click', mode: 'row' } : {};
      this.editConfigPickingDetail = this.isEdit
        ? { trigger: 'click', mode: 'cell', autoClear: true }
        : {};
      this.upDataOption();
    },
    methods: {
      toFixedNumber,
      //限制拣配也不可编辑已删除记录
      editActivedEvent({ row }) {
        console.log(row);
        this.rowDisabled = row.isDeleted == 1;
      },
      // 拣配行合计
      ladingFooterMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['businessLadingAmount'].includes(column.property)) {
              return data
                .map((it) => it.businessLadingAmount)
                .reduce((prev, curr) => {
                  return Number(this.$cal.calCommon(prev, curr, '+').toFixed(2)).toLocaleString(
                    'en-us'
                  );
                }, 0);
            }
            return null;
          }),
        ];
      },
      // 拣配结果合计
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return this.$t('xTable.total');
            }
            if (['businessPickingAmount'].includes(column.property)) {
              return data
                .map((it) => it.businessPickingAmount)
                .reduce((prev, curr) => {
                  return Number(this.$cal.calCommon(prev, curr, '+').toFixed(2)).toLocaleString(
                    'en-us'
                  );
                }, 0);
            }
            if (['pickingQuantity'].includes(column.property)) {
              return data
                .map((it) => it.pickingQuantity)
                .reduce((prev, curr) => {
                  return Number(
                    this.$cal.calCommon(prev, curr, '+').toFixed(this.point)
                  ).toLocaleString('en-us', { minimumFractionDigits: this.point });
                }, 0);
            }
            return null;
          }),
        ];
      },
      rowClassName({ row }) {
        if (row.isDeleted == 1) {
          return 'row-grey';
        }
      },
      checCheckboxkMethod({ row }) {
        return row.isDeleted == 1 ? false : true;
      },
      getDeliveryMenthod() {
        const storageLadingPicking = this.$refs.goodsTable.getTableData().fullData;
        storageLadingPicking.forEach((item) => {
          if (
            this.basicData.deliveryMethod == 'JHFS04' ||
            this.basicData.deliveryMethod == 'JHFS05' ||
            this.basicData.deliveryMethod == 'JHFS06'
          ) {
            this.$set(item, 'nonInvoiceQuantity', item.actualSendQuantity);
          } else {
            this.$set(item, 'nonInvoiceQuantity', 0);
            item.customerReceiveQuantity = 0;
            item.actualSendQuantity = 0;
            this.storageLadingPickingDetailList.forEach((item) => {
              item.actualSendQuantity = 0;
              item.customerReceiveQuantity = 0;
            });
          }
        });
        this.$emit('refreshData', storageLadingPicking);
      },
      //计算实发数量可以输入最大值
      async calMaxActualSendQuantity(scope) {
        if (scope.row.businessInboundBatchNo) {
          let res = await this.$axios.get(API.GET_STORAGEFORPURCHASERETURN, {
            batchNo: scope.row.businessInboundBatchNo,
          });
          if (res.data.code === 0) {
            let returnData = res.data.data;
            scope.row.storageQuantity = returnData.storageQuantity;
            scope.row.availableQuantity = returnData.availableQuantity;
          } else {
            this.$message({ showClose: true, message: res.data.msg, type: 'error' });
          }
        }
        const indexRow = this.storageLadingPicking.findIndex((item) => {
          return scope.row.ladingDetailNo == item.ladingDetailNo;
        });
        this.maxActualSendQuantity =
          Number(this.storageLadingPicking[indexRow].ladingQuantity) *
          (1 + Number(scope.row.overShippedPercentage) / 100);
      },
      //实发数量
      actualSendQuantityChange(val, scope) {
        if (parseFloat(val) > 0) {
          scope.row.actualSendQuantity = val;
          if (this.deleveryFlag) {
            scope.row.shipComplete = 'Y';
          }
        } else if (parseFloat(val) == 0) {
          scope.row.actualSendQuantity = scope.row.pickingQuantity;
          if (this.deleveryFlag) {
            scope.row.shipComplete = 'Y';
          }
        } else {
          scope.row.actualSendQuantity = val;
          scope.row.shipComplete = 'N';
        }
        const indexRow = this.storageLadingPicking.findIndex((item) => {
          return scope.row.ladingDetailNo == item.ladingDetailNo;
        });
        const addNum = [];
        this.storageLadingPickingDetailList.map((itemList) => {
          if (scope.row.ladingDetailNo == itemList.ladingDetailNo) {
            addNum.push(itemList.actualSendQuantity || 0);
          }
        });
        this.storageLadingPicking[indexRow].actualSendQuantity =
          addNum.length == 0
            ? 0
            : addNum.reduce((prev, curr) => {
                return this.$cal.calCommon(prev, curr, '+', 'quantity');
              }, 0);
        Promise.resolve().then(() => {
          //this.storageLadingPicking[indexRow].actualSendQuantity=res;
          if (
            this.basicData.deliveryMethod == 'JHFS04' ||
            this.basicData.deliveryMethod == 'JHFS05' ||
            this.basicData.deliveryMethod == 'JHFS06'
          ) {
            this.storageLadingPicking[indexRow].nonInvoiceQuantity =
              this.storageLadingPicking[indexRow].actualSendQuantity;
          } else {
            this.storageLadingPicking[indexRow].nonInvoiceQuantity = 0;
          }
          //实发总数量
          this.basicData.actualSendQuantityTotal = this.storageLadingPicking
            .map((it) => it.actualSendQuantity)
            .reduce((prev, curr) => {
              return this.$cal.calCommon(prev, curr, '+', 'quantity');
            }, 0);
          this.basicData.actualSendQuantityTotalDesc = toUpperCase(
            this.basicData.actualSendQuantityTotal
          );
          //实发总金额
          this.basicData.actualSendAmountTotal = 0;
          this.storageLadingPicking.forEach((item) => {
            if (!item.actualSendQuantity) {
              this.basicData.actualSendAmountTotal = 0;
            } else {
              this.basicData.actualSendAmountTotal = this.$cal.calCommon(
                this.$cal.calCommon(
                  item.actualSendQuantity,
                  item.businessChangingUnitPrice,
                  '*',
                  'amount'
                ),
                this.basicData.actualSendAmountTotal || 0,
                '+',
                'amount'
              );
            }
          });

          this.basicData.actualSendAmountTotalDesc = digitUppercase(
            this.basicData.actualSendAmountTotal
          );
          this.$emit('refreshData', this.storageLadingPicking);
        });
      },
      //客户实收数量
      cusReceiveQuantityChange(val, scope) {
        let addNum = [];
        const indexRow = this.storageLadingPicking.findIndex((item) => {
          return scope.row.ladingDetailNo == item.ladingDetailNo;
        });
        this.storageLadingPickingDetailList.map((itemList) => {
          if (scope.row.ladingDetailNo == itemList.ladingDetailNo) {
            addNum.push(itemList.customerReceiveQuantity || 0);
          }
        });
        this.storageLadingPicking[indexRow].customerReceiveQuantity =
          addNum.length == 0
            ? 0
            : addNum.reduce((prev, curr) => {
                return this.$cal.calCommon(prev, curr, '+', 'quantity');
              }, 0);
        Promise.resolve().then(() => {
          //this.storageLadingPicking[indexRow].customerReceiveQuantity=res;
          /*if(this.basicData.deliveryMethod == 'JHFS04' ||this.basicData.deliveryMethod == 'JHFS05' ||this.basicData.deliveryMethod == 'JHFS06'){
            this.storageLadingPicking[indexRow].nonInvoiceQuantity= this.storageLadingPicking[indexRow].customerReceiveQuantity
          }else{
            this.storageLadingPicking[indexRow].nonInvoiceQuantity=0
          }*/
          this.$emit('refreshData', this.storageLadingPicking);
        });
      },
      //变动单价
      changeSelect(val, scope) {
        if (val || val == 0) {
          scope.row.priceFlag = val;
          let obj = scope.row.priceOptions.find((item) => {
            return item.priceFlag == val;
          });
          scope.row.businessChangingUnitPrice = obj.temporaryPrice;
          scope.row.pricingId = obj.id;
          scope.row.maxQuantity = obj.availableLadingQuantity;
          if (Number(scope.row.maxQuantity) < Number(scope.row.ladingQuantity)) {
            scope.row.ladingQuantity = scope.row.maxQuantity;
            this.ladingQuantityChange(scope.row.ladingQuantity, scope.row, scope);
          }
        } else {
          scope.row.priceFlag = '';
          scope.row.pricingId = '';
          scope.row.maxQuantity = scope.row.availableQuantity;
          scope.row.businessChangingUnitPrice = '';
          scope.row.temporaryPrice = null;
        }
        this.$refs.goodsTable.reloadRow(scope.row);
        this.$refs.goodsTable.updateStatus(scope);
        this.calcQuantityChange(val, scope.row, scope);
        this.$emit('refreshData', this.storageLadingPicking);
      },
      //数据重组-下拉
      upDataOption() {
        this.storageLadingPicking.forEach((item) => {
          if (!item.customerReceiveQuantity) {
            this.$set(item, 'customerReceiveQuantity', 0);
          }
          if (!item.actualSendQuantity) {
            this.$set(item, 'actualSendQuantity', 0);
          }
          // if(this.basicData.deliveryMethod == 'JHFS04' ||this.basicData.deliveryMethod == 'JHFS05' ||this.basicData.deliveryMethod == 'JHFS06'){
          //  this.$set(item, 'nonInvoiceQuantity', item.customerReceiveQuantity)
          // }else{
          //   this.$set(item, 'nonInvoiceQuantity', 0)
          // }
          this.getPriceList(item);
        });
      },
      //变动单价
      async getPriceList(row) {
        let obj = {
          contractDetailNo: row.contractDetailNo,
          contractNo: row.contractNo,
          currency: this.basicData.ladingCurrency,
        };
        if (this.$route.query.ladingNo) {
          obj.ladingNo = this.$route.query.ladingNo;
        }
        const res = await this.$axios.post(API.GET_PRICE_LIST, obj);
        if (res.data.code == 0) {
          this.$set(row, 'priceOptions', res.data.data);
          row.maxQuantity = row.availableQuantity;
          if (row.priceFlag) {
            row.maxQuantity = res.data.data.find((item) => {
              return item.priceFlag == row.priceFlag;
            })?.availableLadingQuantity;
          }
        }
        this.$refs.goodsTable.updateStatus();
      },
      //业务入库批次拣配
      batchPicking() {
        const selections = this.$refs.goodsTable.getCheckboxRecords();
        if (selections.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.selectOneMatching'),
            type: 'error',
          });
          return;
        }
        if (!selections[0].ladingQuantity || selections[0].ladingQuantity == '0') {
          this.$message({
            showClose: true,
            message: this.$t('salesBill.message.goodsDetailMatched'),
            type: 'error',
          });
          return;
        }
        // const rowIndex = this.$refs.goodsTable.$getRowIndex(selections[0]) + 1;
        const rowIndex = selections[0].ladingDetailNo; //提单号
        this.$refs.batchPickingDialog.chooseGoods(selections, rowIndex, this.basicData);
      },
      //抛出表格数据
      exportTableData() {
        let storageLadingPickingList = this.$refs.goodsTable
          .getTableData()
          .fullData.filter((it) => it.isDeleted === 0 || it.isDeleted == null);
        let storageLadingPickingDetailList = this.$refs.resultTable
          .getTableData()
          .fullData.filter((it) => it.isDeleted === 0 || it.isDeleted == null);
        storageLadingPickingDetailList.map((item) => {
          item.shipComplete = item.actualSendQuantity > 0 && this.deleveryFlag ? 'Y' : 'N';
          const result = item;
          delete result.gmtCreate;
          return result;
        });
        let obj = {
          storageLadingPickingList,
          storageLadingPickingDetailList,
        };
        return obj;
      },
      //根据合同号查询溢装值
      getOvershippend(contractNo) {
        this.$axios.post(API.LIST_PRODUCT_API, { contractNo }).then((res) => {
          if (res.data.code == 0) {
            res.data.data.forEach((item) => {
              this.storageLadingPickingDetailList.forEach((item1, index) => {
                if ((item.contractDetailNo = item1.contractDetailNo)) {
                  this.storageLadingPickingDetailList[index].overShippedPercentage =
                    item.overShippedPercentage;
                }
              });
            });
          }
        });
      },
      //校验
      validateAll() {
        let formArr = ['goodsTable', 'resultTable']; //两个表格
        var resultArr = []; //用来接受返回结果的数组
        var _self = this;
        function checkForm(formName) {
          //封装验证表单的函数
          var result = new Promise(function (resolve, reject) {
            _self.$refs[formName].validate((valid) => {
              if (valid) {
                resolve();
              } else {
                reject();
              }
            });
          });
          resultArr.push(result); //push 得到promise的结果
        }
        formArr.forEach((item) => {
          //根据表单的ref校验
          checkForm(item);
        });
        return Promise.all(resultArr);

        /* return new Promise((resolve, reject) => {
        this.$refs.goodsTable.validate(valid => {
          valid ? resolve() : reject();
        }).catch((e) => { });
      }) */
      },
      //接收拣配结果
      changeResult(arr) {
        arr.forEach((item) => {
          item.productNo = item.productDetailNo;
          item.productDesc = item.productName;
          // item.identifyingCode = item.identifyingCode;
          item.ladingUnitName = item.productUnitName;
          item.unit = item.productUnit;
          item.supplier = item.partnerName;
          item.businessContractUnitPrice = item.businessUnitPriceWithTax;
          item.businessPickingAmount = item.businessTotlePriceWithTax;
          item.businessInboundBatchNo = item.batchNo;
          item.customerReceiveQuantity = 0;
          item.currencyName = item.currencyTypeName;
          item.currencyCode = item.currencyTypeCode;
        });
        // 相同行项目号的数据先筛选出去，再拼接数据
        const ladingDetailNo = arr[0].ladingDetailNo;
        this.storageLadingPickingDetailList = this.storageLadingPickingDetailList.filter((item) => {
          return item.ladingDetailNo != ladingDetailNo;
        });
        // this.storageLadingPickingDetailList = this.storageLadingPickingDetailList.concat(arr);
        // 相同行项目号的数据先筛选出去，再拼接数据
        // const ladingDetailNo = arr[0].ladingDetailNo;
        // this.storageLadingPickingDetailList = this.storageLadingPickingDetailList.filter((item) => {
        //   return item.ladingDetailNo != ladingDetailNo;
        // });
        const params = {
          exchangeRate: 1,
          storageLadingPickingDetailList: arr,
        };
        // 计算拣配金额
        this.$axios
          .post(API.CALC_PICK_DETAIL, params)
          .then((res) => {
            if (res.data.code == 0) {
              const list = res.data.data.storageLadingPickingDetailList || [];
              arr.forEach((item, index) => {
                // 拣配金额
                const result = list[index] || {};
                item.businessPickingAmount = result.businessPickingAmount || 0;
                item.businessPickingAmountOther = result.businessPickingAmountOther || '';
                // 合同单价计算汇率后的值
                item.businessContractUnitPriceOther = result.businessContractUnitPriceOther || '';
              });
            }
          })
          .then(() => {
            this.storageLadingPickingDetailList = this.storageLadingPickingDetailList.concat(arr);
          })
          .catch(() => {
            this.storageLadingPickingDetailList = this.storageLadingPickingDetailList.concat(arr);
          });
      },
      calcQuantityChange(val, row, scope) {
        console.log(val, row, scope);
        //计算销售提单批次拣配金额、运费总金额（表格加运费总金额）
        /* let storageLadingPickingCurrencyList = [];
      this.storageLadingPicking.map(item => {
        let obj = {
          businessChangingUnitPrice: item.businessChangingUnitPrice,
          businessContractUnitPrice: item.businessContractUnitPrice,
          businessDeliveryExpenseUnitPrice: item.businessDeliveryExpenseUnitPrice,
          ladingQuantity: item.ladingQuantity,
        }
        storageLadingPickingCurrencyList.push(obj);
      })
      let params = {
        exchangeRate: this.basicData.exchangeRate,//汇率暂时没有先写死
        storageLadingPickingCurrencyList: storageLadingPickingCurrencyList
      }
      this.$axios.post(API.CALC_PICKING_API, params).then(res => {
        if (0 == res.data.code) {
          let newArr = res.data.data.storageLadingPickingCurrencyList;
          this.storageLadingPicking.map((item, index) => {
            item.businessLadingAmount = newArr[index].businessLadingAmount;
            item.businessLadingAmountOther = newArr[index].businessLadingAmountOther;
            item.businessChangingUnitPrice = newArr[index].businessChangingUnitPrice;
            item.businessChangingUnitPriceOther = newArr[index].businessChangingUnitPriceOther;
            item.businessContractUnitPrice = newArr[index].businessContractUnitPrice;
            item.businessContractUnitPriceOther = newArr[index].businessContractUnitPriceOther;
            item.businessDeliveryExpenseUnitPrice = newArr[index].businessDeliveryExpenseUnitPrice;
            item.businessDeliveryExpenseUnitPriceOther = newArr[index].businessDeliveryExpenseUnitPriceOther;
          })
          let businessDeliveryExpenseAmount = res.data.data.businessDeliveryExpenseAmount;
          let businessDeliveryExpenseAmountOther = res.data.data.businessDeliveryExpenseAmountOther;
          this.$emit('calcLadingPicking', res.data.data, this.storageLadingPicking);
          this.getBasicTotal();
        }
      }); */
        this.calcQuantityChangeBySelf();
      },
      calcQuantityChangeBySelf() {
        //计算销售提单批次拣配金额、运费总金额（表格加运费总金额）
        let storageLadingPickingCurrencyList = [];
        this.storageLadingPicking.map((item) => {
          let obj = {
            businessChangingUnitPrice: item.businessChangingUnitPrice,
            businessChangingUnitPriceOther: this.$cal.calCommon(
              item.businessChangingUnitPrice,
              this.basicData.exchangeRate,
              '*',
              'price'
            ),
            businessContractUnitPrice: item.businessContractUnitPrice,
            businessContractUnitPriceOther: this.$cal.calCommon(
              item.businessContractUnitPrice,
              this.basicData.exchangeRate,
              '*',
              'price'
            ),
            businessDeliveryExpenseUnitPrice: item.businessDeliveryExpenseUnitPrice,
            businessDeliveryExpenseUnitPriceOther: this.$cal.calCommon(
              item.businessDeliveryExpenseUnitPrice,
              this.basicData.exchangeRate,
              '*',
              'price'
            ),
            ladingQuantity: item.ladingQuantity,
            businessLadingAmount: this.$cal.calCommon(
              item.businessChangingUnitPrice,
              item.ladingQuantity,
              '*'
            ),
            businessLadingAmountOther: this.$cal.calCommon(
              this.$cal.calCommon(item.businessChangingUnitPrice, item.ladingQuantity, '*'),
              this.basicData.exchangeRate,
              '*'
            ),
          };
          storageLadingPickingCurrencyList.push(obj);
        });
        //获取原来后台返回的主表信息
        let ladingTotalQuantity = new Big(0);
        let businessLadingTotalAmount = 0;
        let businessLadingTotalAmountOther = 0;
        let businessDeliveryExpenseAmount = 0; //运输费
        let businessDeliveryExpenseAmountOther = 0; //运输费本币
        // let businessOutboundExpenseAmount = 0; //出库费
        // let businessOutboundExpenseAmountOther = 0; //出库费
        // let businessStorageExpenseAmount = 0; //仓储费
        // let businessStorageExpenseAmountOther = 0; //仓储费

        let newArr = storageLadingPickingCurrencyList;
        this.storageLadingPicking.map((item, index) => {
          item.businessLadingAmount = newArr[index].businessLadingAmount;
          item.businessLadingAmountOther = newArr[index].businessLadingAmountOther;
          item.businessChangingUnitPrice = newArr[index].businessChangingUnitPrice;
          item.businessChangingUnitPriceOther = newArr[index].businessChangingUnitPriceOther;
          item.businessContractUnitPrice = newArr[index].businessContractUnitPrice;
          item.businessContractUnitPriceOther = newArr[index].businessContractUnitPriceOther;
          item.businessDeliveryExpenseUnitPrice = newArr[index].businessDeliveryExpenseUnitPrice;
          item.businessDeliveryExpenseUnitPriceOther =
            newArr[index].businessDeliveryExpenseUnitPriceOther;
        });

        this.storageLadingPicking.forEach((item) => {
          if (!item.ladingQuantity) {
            item.ladingQuantity = 0;
          } else {
            ladingTotalQuantity = ladingTotalQuantity.plus(item.ladingQuantity);
            businessLadingTotalAmount = this.$cal.calCommon(
              item.businessLadingAmount,
              businessLadingTotalAmount,
              '+',
              'amount'
            );
            businessLadingTotalAmountOther = this.$cal.calCommon(
              item.businessLadingAmountOther,
              businessLadingTotalAmountOther,
              '+',
              'amount'
            );
            businessDeliveryExpenseAmount = this.$cal.calCommon(
              this.$cal.calCommon(
                item.businessDeliveryExpenseUnitPrice,
                item.ladingQuantity,
                '*',
                'price'
              ),
              businessDeliveryExpenseAmount,
              '+',
              'amount'
            );
            businessDeliveryExpenseAmountOther = this.$cal.calCommon(
              this.$cal.calCommon(
                item.businessDeliveryExpenseUnitPriceOther,
                item.ladingQuantity,
                '*',
                'price'
              ),
              businessDeliveryExpenseAmountOther,
              '+',
              'amount'
            );
          }
        });
        let obj = {
          ladingTotalQuantity: ladingTotalQuantity.toFixed(8),
          businessLadingTotalAmount,
          businessLadingTotalAmountOther,
          businessDeliveryExpenseAmount,
          businessDeliveryExpenseAmountOther,
        };
        obj = { ...obj, ...this.storageLadingPicking };

        this.$emit('calcLadingPicking', obj, this.storageLadingPicking);
        this.getBasicTotal();
      },
      //提单数量发生变化 判断是否已经拣配 如果已拣配 则清空该商品明细下的拣配结果
      ladingQuantityChange(val, row, scope) {
        // row.nonInvoiceQuantity = val;
        let rowHasLading = false; //默认没有拣配过
        let sameLength = 0; //如果拣配过有几项
        let startIndex = 0; //如果拣配过 头的索引
        let sameQuantity = 0; // 拣配总数量
        let isDeletedFlag = 0; // 未删除
        // const rowIndex = this.$refs.goodsTable.$getRowIndex(row) + 1;
        const rowIndex = scope.data[scope.rowIndex].contractDetailNo;
        this.storageLadingPickingDetailList.forEach((item, index) => {
          if (rowIndex == item.ladingDetailNo) {
            //已经拣配过
            rowHasLading = true;
            sameLength += 1;
            startIndex = index;
            sameQuantity += Number(item.pickingQuantity);
            isDeletedFlag = item.isDeleted;
          }
        });
        startIndex = startIndex - sameLength + 1;
        if (rowHasLading && (sameQuantity != val || isDeletedFlag != val)) {
          //已经拣配过 确认将会删除 相关明细
          this.$confirmAction('', this.$t('salesBill.message.dueChangeMatching'))
            .then(() => {
              this.calcQuantityChange(val, row, scope);
              // 确认选择这个仓库：清空商品行数据
              this.storageLadingPickingDetailList.splice(startIndex, sameLength);
            })
            .catch(() => {
              // 恢复是否删除
              row.isDeleted = isDeletedFlag;
              // 恢复提单数量
              row.ladingQuantity = sameQuantity;
              this.storageLadingPicking[scope.rowIndex].ladingQuantity = sameQuantity;
              this.storageLadingPicking[scope.rowIndex].isDeleted = isDeletedFlag;
              this.$emit('refreshData', this.storageLadingPicking);
              this.getBasicTotal();
            });
        } else {
          this.calcQuantityChange(val, row, scope);
        }
      },
      getBasicTotal() {
        let ladingTotalQuantity = new Big(0);
        let businessLadingTotalAmount = new Big(0);
        let businessLadingTotalAmountOther = new Big(0);
        this.storageLadingPicking.forEach((item) => {
          if (!item.ladingQuantity) {
            item.ladingQuantity = 0;
          } else {
            ladingTotalQuantity = ladingTotalQuantity.plus(item.ladingQuantity);
            businessLadingTotalAmount = businessLadingTotalAmount.plus(item.businessLadingAmount);
            businessLadingTotalAmountOther = businessLadingTotalAmountOther.plus(
              item.businessLadingAmountOther
            );
          }
        });
        let parent = this.$refs.goodsTable.$parent.basicData;
        //更新提单总额
        // ladingTotalQuantity = this.$cal.calCommon(ladingTotalQuantity.toFixed(6), 0, '+', 'quantity');
        // businessLadingTotalAmount = this.$cal.calCommon(
        //   businessLadingTotalAmount,
        //   0,
        //   '+',
        //   'amount'
        // );
        // businessLadingTotalAmountOther = this.$cal.calCommon(
        //   businessLadingTotalAmountOther,
        //   0,
        //   '+',
        //   'amount'
        // );
        parent.ladingTotalQuantity = ladingTotalQuantity.toFixed(8);
        parent.ladingTotalQuantityDesc = toUpperCase(ladingTotalQuantity);
        parent.businessLadingTotalAmount = businessLadingTotalAmount.toFixed(6);
        parent.businessLadingTotalAmountOther = businessLadingTotalAmountOther.toFixed(6);
        console.log(
          ladingTotalQuantity.toFixed(8),
          businessLadingTotalAmount.toFixed(6),
          '计算后数据'
        );
        if (parent.ladingCurrency == 'CNY') {
          parent.ladingTotalAmountDesc = digitUppercase(businessLadingTotalAmount);
        } else {
          parent.ladingTotalAmountDesc = '';
        }
      },
      changeList(val, row, scope) {
        row.ladingQuantity = val;
        row.actualSendQuantity = val;
        // row.businessLadingAmount = row.businessContractUnitPrice*Number(val);
        this.$refs.goodsTable.updateStatus(scope);
        // let parent = this.$refs.goodsTable.$parent.basicData

        // let ladingTotalQuantity = 0;
        // let businessLadingTotalAmount = 0;
        // this.storageLadingPicking.forEach(item=>{
        //   if(!item.ladingQuantity){
        //     item.ladingQuantity = 0;
        //   }else{
        //     ladingTotalQuantity+= Number(item.ladingQuantity);
        //     businessLadingTotalAmount+= Number(item.businessLadingAmount);
        //   }
        // })
        // //更新提单总额
        // parent.ladingTotalQuantity = ladingTotalQuantity;
        // parent.ladingTotalQuantityDesc = toUpperCase(ladingTotalQuantity);
        // parent.businessLadingTotalAmount = businessLadingTotalAmount;
        // if(parent.ladingCurrency=="CNY"){
        //  parent.ladingTotalAmountDesc = digitUppercase(businessLadingTotalAmount);
        // }else{
        //  parent.ladingTotalAmountDesc=""
        // }
      },
      deliveryExpenseUnitPriceChange(val, row, scope) {
        this.calcQuantityChange(val, row, scope);
        this.$refs.goodsTable.reloadRow(row);
        this.$refs.goodsTable.updateStatus(scope);
        this.$emit('refreshData', this.storageLadingPicking);
      },
      //清空
      cleanResult() {
        this.storageLadingPickingDetailList = [];
      },
      //清空所有拣配结果
      emptyPicking() {
        this.$confirmAction('', this.$t('salesBill.message.emptyPicking'))
          .then(() => {
            this.storageLadingPickingDetailList = [];
          })
          .catch(() => {});
      },
      refreshPage(obj) {
        console.log('更新表格2的数据', obj);
        this.keyTime = new Date().getTime();
        this.storageLadingPicking = JSON.parse(JSON.stringify(obj));
      },
      // 接口加法计算
      calculateAdd(adds) {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_ADD_AMOUNT, { adds }).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
              reject();
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .inputWidth {
    width: 100% !important;
  }
  .tabContent {
    padding: 10px;
    background-color: #fff;
  }
  .break-space {
    white-space: nowrap;
    line-height: 18px;
  }
  .mytable-style > .vxe-body--row.row-grey {
    background-color: #f5f7fa !important;
  }
</style>
<style lang="scss">
  // .el-select-dropdown__empty{
  //   display: none;
  // }
</style>
